export const iconView = (status) => {
  if (status === "placed" || status === "confirmed") {
    return "fas fa-box";
  } else if (status === "delivered") {
    return "fas fa-check";
  } else if (status === "onHold") {
    return "fas fa-hand-paper";
  } else if (status === "cancelled" || status === "rejected") {
    return "fas fa-times";
  } else {
    return "fas fa-truck";
  }
};
export const iconColor = (status) => {
  if (status === "placed" || status === "confirmed") {
    return { color: "#1E44C1" };
  } else if (status === "delivered") {
    return { color: "#28a745" };
  } else if (status === "onHold") {
    return { color: "#edb91c" };
  } else if (status === "cancelled" || status === "rejected") {
    return { color: "#ff3b30" };
  } else {
    return { color: "grey" };
  }
};
export const spanStatus = (status) => {
  if (status === "placed") {
    return "Menunggu Dikirim";
  } else if (status === "confirmed") {
    return "Sedang mencari kurir";
  } else if (status === "rejected") {
    return "Pengiriman Ditolak";
  } else if (status === "courierNotFound") {
    return "Kurir tidak ditemukan";
  } else if (status === "allocated") {
    return "Kurir sudah diinfo";
  } else if (status === "pickingUp") {
    return "Menjemput Barang";
  } else if (status === "picked") {
    return "Barang telah dijemput";
  } else if (status === "pending") {
    return "Belum Pembayaran";
  } else if (status === "droppingOff") {
    return "Menuju Lokasi Penerima";
  } else if (status === "delivered") {
    return "Tiba di Tujuan";
  } else if (status === "onHold") {
    return "Ditahan Sementara";
  } else if (status === "cancelled") {
    return "Dibatalkan";
  } else if (status === "returned") {
    return "Barang Telah Dikembalikan";
  } else if (status === "disposed") {
    return "Barang Telah Dibuang";
  } else if (status === "returnInTransit") {
    return "Sedang Dalam Perjalanan";
  }
};

export const filterTracking = (data, filter) => {
  let filteredData;
  if (filter === "disimpan") filteredData = data.filter((item) => item.status === "placed");
  else if (filter === "menunggu")
    filteredData = data.filter(
      (item) =>
        item.status === "confirmed" || item.status === "allocated" || item.status === "pickingUp"
    );
  else if (filter === "perjalanan")
    filteredData = data.filter((item) => item.status === "picked" || item.status === "droppingOff");
  else if (filter === "selesai")
    filteredData = data.filter(
      (item) =>
        item.status === "delivered" ||
        item.status === "returned" ||
        item.status === "cancelled" ||
        item.status === "rejected" ||
        item.status === "disposed" ||
        item.status === "courierNotFound"
    );
  else if (filter === "retur")
    filteredData = data.filter((item) => item.status === "returnInTransit");
  else if (filter === "lainnya")
    filteredData = data.filter((item) => item.status === "onHold" || item.status === "pending");
  else filteredData = data;

  return filteredData;
};
